var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-1"},[(_vm.group)?_c('h1',{staticClass:"m-0 p-0"},[_vm._v(_vm._s(_vm.group.group_name))]):_vm._e(),_c('group-calendar'),_c('group-manage-options'),_c('group-connected-apps'),_c('group-files-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }